export const SEARCH_LOCATIONS = "SEARCH_LOCATIONS";
